import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import ServicesPageMainContainer from '../../components/services/ServicesPageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
// Consntants
import { CompanyName, LocationCity } from '../../utils/Constants';
// Data
import {
  servicesPageAdditionalMeta,
  servicesPageStructuredData,
} from '../../utils/data/MetaData';

const ServicesPage = React.memo(() => {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Services'
        desc={`Explore the range of professional services offered by ${CompanyName}, a seasoned dominatrix based in ${LocationCity}. Discover tailored BDSM sessions, each designed to provide unforgettable, intimate experiences that cater to individual desires and boundaries. Learn about ${CompanyName}'s unique approach to domination and personal empowerment.`}
        keywords={`services, ${CompanyName}, dominatrix, BDSM, professional services, intimate experiences, domination, ${LocationCity}, tailored sessions`}
        additionalMeta={servicesPageAdditionalMeta}
        structuredData={servicesPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden text-colour1 font-poppins w-full no__highlights'>
        <div className='grid grid-rows-reg w-full'>
          {/* Navigation */}
          <header className='paralax min-h-screen fixed bg-para4 bg-cover bg-no-repeat w-full bg-center'>
            <Navbar />
            <div className='grid lg:mt-10 h-full p-6 lg:py-2 text-xl leading-relaxed text-colour1'>
              <div className='grid gap-y-8 lg:gap-y-12 lg:justify-between h-fit pl-4 font-argesta'>
                <div>
                  <h1 className='text-3xl lg:text-4xl italic'>
                    ”Some of My specialities".....
                  </h1>
                </div>
                <div className='grid h-fit text-base font-medium italic lg:text-2xl'>
                  <p>Anal Play / Figging / Pegging / Strap </p>
                  <p>on / Foot / Boot / Stocking Worship</p>
                  <p>Caning / Edging / Shibari Rope </p>
                  <p>Bondage / CBT / GS / Tease & </p>
                  <p>Denial / Corporal Punishment /</p>
                  <p>Ballbusting / Chastity / Electrics</p>
                  <p>Needles / Forced Feminisation /</p>
                  <p>Humiliation / Sounds / Spanking</p>
                  <p>Smothering / Trampling / Latex /</p>
                  <p>Ruined Orgasms / Spitting / Nipple </p>
                  <p>Torture / slave Training / Tickle Torture</p>
                </div>
                <div>
                  <p className='italic lg:text-lg'>
                    If your particular interest is not <br /> listed here you
                    may politely ask...
                  </p>
                </div>
              </div>
            </div>
          </header>

          {/* Main page content */}
          <ServicesPageMainContainer />
        </div>
      </div>
    </>
  );
});

export default ServicesPage;
